var Industry = "Sektör";
var Aerospace = "Havacılık ve Uzay";
var Agriculture = "Tarım";
var Automotive = "Otomotiv";
var Education = "Eğitim";
var Gaming = "Oyun";
var Government = "Devlet";
var Healthcare = "Sağlık Hizmetleri";
var Hospitality = "Konaklama";
var Manufacturing = "Üretim";
var Mining = "Madencilik";
var Other = "Diğer";
var Retail = "Perakende";
var Telecommunications = "Telekomünikasyon";
var Travel = "Seyahat";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Bilgisayar ve Elektronik",
	"Consumer goods": "Tüketici Ürünleri",
	Education: Education,
	"Financial services": "Finansal Hizmetler",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Yaşam Bilimleri",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Pazarlama ve Reklam",
	"Media & entertainment": "Medya ve Eğlence",
	Mining: Mining,
	"Non-profit organization": "Kâr Amacı Gütmeyen Kuruluş",
	"Oil & gas": "Petrol ve Doğal Gaz",
	Other: Other,
	"Power & utilities": "Elektrik ve Kamu Hizmetleri",
	"Professional services": "Profesyonel Hizmetler",
	"Real estate & construction": "Emlak ve İnşaat",
	Retail: Retail,
	"Software & internet": "Yazılım ve İnternet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Taşımacılık ve Lojistik",
	Travel: Travel,
	"Wholesale & distribution": "Toptan Satış ve Dağıtım"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
